import { useRouter } from "@tanstack/react-router";
import {
  type BestillingPageKey,
  bestillingFormPageOrder,
} from "@/features/bestillinger";

export function useBestillingNavigation(currentPage: BestillingPageKey): {
  navigateNext: () => Promise<void>;
  navigatePrevious: () => Promise<void>;
  currentStep: number;
  isFirstStep: boolean;
  isLastStep: boolean;
  totalSteps: number;
} {
  const router = useRouter();
  const currentIndex = bestillingFormPageOrder.indexOf(currentPage);
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === bestillingFormPageOrder.length - 1;
  const totalSteps = bestillingFormPageOrder.length;
  const currentStep = currentIndex + 1;

  const navigateNext = async () => {
    if (isLastStep) {
      return Promise.resolve();
    }
    const nextPage = bestillingFormPageOrder[currentIndex + 1];
    return await router.navigate({ to: nextPage, params: {} });
  };
  const navigatePrevious = async () => {
    if (isFirstStep) {
      return Promise.resolve();
    }
    const previousPage = bestillingFormPageOrder[currentIndex - 1];
    return await router.navigate({ to: previousPage, params: {} });
  };

  return {
    navigateNext,
    navigatePrevious,
    currentStep,
    isFirstStep,
    isLastStep,
    totalSteps,
  };
}
